import { C_SERVICE_TYPE, C_STATE, ResContracts } from "@/api/contract";
export interface ServiceType {
  title: string;
  list: ResContracts[];
}

/** 是否显示空状态 */
const IS_EMPTY = true;

export const classify = (list: ResContracts[], key = "cServiceType"): ServiceType[] => {
  console.groupCollapsed("分类", list, key);
  const keys = Object.keys(key == "cServiceType" ? typeName : key == "conStopState" && stateName);
  const arr: ServiceType[] = IS_EMPTY ? keys.map((title) => ({ title, list: [] })) : [];

  list.forEach((item) => {
    console.log(item, item[key]);
    const o = arr.find((n) => n.title == String(item[key]));
    if (o) o.list.push(item);
    else arr.push({ title: String(item[key]), list: [item] });
  });
  console.log(arr);
  console.groupEnd();
  return arr;
};

export const typeName: {
  [key in C_SERVICE_TYPE]: string;
} = {
  [C_SERVICE_TYPE.ONE]: "代理记账",
  [C_SERVICE_TYPE.TWO]: "工商注册",
  [C_SERVICE_TYPE.THREE]: "其它业务",
};

export const stateName = {
  false: "进行中合同",
  true: "已终止合同",
};

export const stateColor: {
  [key in C_STATE]: string;
} = {
  [C_STATE.ONE]: "#979797",
  [C_STATE.TWO]: "#f97f32",
  [C_STATE.THREE]: "#85be71",
  [C_STATE.FOUR]: "#000",
};
export const getName = (type: string): string => typeName?.[type] || stateName[type];
